export class CommunicationSenderModel {
	id: string;
	title: string;
	description: string;
	additional?: boolean;
}
